import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import { usePageView } from 'hooks'
import { getStaticWrapper } from 'utils'

const ContentPolicy = () => {
  usePageView()
  return (
    <SiteLayout hideBanner>
      <Head title='Content Policy | Barstool Sports' />
      <section className='container'>
        <article className='staticPage'>
          <header className='staticPage__header'>
            <h1>Exclusive Content License &amp; Submission Policy</h1>
          </header>
          <section className='staticPage__content'>
            <p>
              Barstool Sports, Inc. (“Barstool” or “we”, “our” or “us”) operates the Barstool Sports platform, including
              our websites, social media pages and apps (the foregoing shall hereinafter be collectively referred to as
              the “Platform”).
            </p>
            <p>
              This Exclusive Content License &amp; Submission Policy (“Agreement”) describes the agreement between you
              and us with respect to any content or materials, including photos, videos and written pieces
              (collectively, “Your Content”), added, submitted, distributed, or posted to the Platform by any means
              including, without limitation, via upload, e-mail, DM and/or posted comment, and governs your rights,
              licenses, obligations and restrictions regarding submission of Your Content to the Platform.{' '}
            </p>
            <h3>EXCLUSIVE LICENSE GRANT</h3>
            <p>
              By submitting or posting Your Content to us or our Platform in any manner, and in consideration for the
              opportunity to have Your Content distributed on our Platform, you automatically grant us and our
              contributors, or warrant that the owner of such content has expressly granted us, the perpetual,
              irrevocable, sublicensable and transferable, exclusive right and license to use, copy, reproduce, publish,
              distribute, license to others, perform, enforce, edit, modify, prepare derivative works of, and otherwise
              exploit Your Content, and any clips, images, or portions thereof, in any and all media, formats and
              channels, including on our Platform, and in merchandise related thereto.{' '}
            </p>
            <p>
              For the sake of clarity, the rights granted with respect to Your Content will include, without limitation,
              the exclusive right to (1) post Your Content on our Platform, (2) use Your Content (or clips thereof) in
              advertising/ promotional material, (3) license Your Content to third parties for their use in exchange for
              payment, (4) pursue advertising, brand integration, endorsement and sponsorship opportunities with respect
              to Your Content; (5) pursue and receive fees and damages for past, present and future infringements of
              intellectual property rights in and to Your Content, and (6) incorporate Your Content, or images
              therefrom, in merchandise to be sold through the Platform or otherwise (e.g., apparel).{' '}
            </p>
            <p>
              The rights granted by you to us are exclusive which means that after entering this license, you will have
              no right to grant rights in Your Content to any third party and no right to continue to distribute Your
              Content through your own digital or online channels (including your own social media accounts), unless we
              otherwise agree.
            </p>
            <p>
              To the extent any of Your Content you submit includes name, image, voice, or performance of you or anyone
              else, you acknowledge and agree that licenses herein shall apply to the same. Except where prohibited by
              applicable law, by submitting Your Content through the Platform, you are waiving and agreeing not to
              assert any of the following potential claims based upon our use of Your Content as described herein: (i)
              copyright infringement; (ii) violation of your rights of publicity; (iii) defamation, and/or (iv) “moral”
              rights or claims resulting from our alteration of Your Content.{' '}
            </p>
            <p>Subject to these grants, you retain any and all rights which may exist in Your Content.</p>
            <p>
              We do not guarantee that any of Your Content will be exploited through the Platform. We reserve the right
              to, but do not have any obligation to, remove, edit, modify or otherwise manipulate Your Content in our
              sole discretion, at any time, without notice to you and for any reason (including, but not limited to,
              upon receipt of claims or allegations from third parties or authorities relating to Your Content or if we
              are concerned that Your Content may violate this Agreement).
            </p>
            <h3>PROHIBITED CONTENT</h3>
            <p>You are prohibited from submitting or posting to the Platform any content that:</p>
            <ol>
              <li>
                Was taken from a third party, or includes a third party’s trademarks, content or material, without
                permission, or otherwise infringes upon a third party’s intellectual property rights of any kind.
              </li>
              <li>You have previously sold to or exclusively licensed to another party.</li>
              <li>Is defamatory, slanderous or libelous.</li>
              <li>
                Depicts or encourages criminal or tortious activity, including fraud, trafficking in obscene or illegal
                material, drug dealing or using, underage drinking, gambling, violence, harassment, or stalking.{' '}
              </li>
              <li>
                Includes the name, image, voice or performance of any person who has not provided his or her consent to
                the foregoing being used for the purposes hereunder.
              </li>
              <li>Depicts or encourages dangerous activities.</li>
              <li>Is abusive, threatening, or obscene.</li>
            </ol>
            <br />
            <h3>REPRESENTATIONS AND WARRANTIES</h3>
            <p>
              You represent and warrant that Your Content will not violate any of the prohibitions described above.{' '}
            </p>
            <p>Without limiting the foregoing, you further represent and warrant that:</p>
            <ol>
              <li>
                You did not, without necessary permission, copy, rip, download, or otherwise take Your Content from any
                third party.{' '}
              </li>
              <li>
                You have not previously granted, nor will you in the future grant, any rights to Your Content to any
                third party.
              </li>
              <li>
                You own or have the necessary licenses, rights, consents, and permissions to use and authorize us to
                include and use Your Content in the manner contemplated by this Agreement and that Your Content will not
                violate or infringe upon the intellectual property rights, the rights of privacy or publicity, or any
                other rights of any third party.
              </li>
              <li>
                You have the express consent of every party prominently featured in Your Content to license Your Content
                to us for the uses contemplated under this Agreement.
              </li>
            </ol>
            <br />
            <h3>INCORPORATION OF TERMS OF USE</h3>
            <p>
              This Agreement supplements our <a href='/terms-of-use'>Terms of Use</a> , the provisions of which are
              hereby incorporated by this reference and constitute the remainder of the terms governing the submission
              of Your Content. By submitting Your Content, you are representing that you have read and agree to both
              agreements.
            </p>
            <p>Please contact us at [support@barstoolsports.com] with any questions regarding this Agreement.</p>
          </section>
        </article>
      </section>
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default ContentPolicy
